import { Component, OnInit } from '@angular/core';
import { ApiHandlerService } from '../api-handler.service';
import { environment } from "../../environments/environment";
declare var $: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  private apiUrl = 'https://muvmadebmf.execute-api.us-east-1.amazonaws.com/prod/';
  public email = "";
  currentDate = new Date();
  constructor(private apiHandler : ApiHandlerService) { }

  ngOnInit() {
  }
  subscribeToNewsletter(){
    if(this.email){
      this.apiHandler.post(this.apiUrl,{ email: this.email }).subscribe(result=>{
        console.log(result);
        $('#subscribed-modal').modal('show');
      })
    }
  }

  showTCAndRefundPolicy(slug:string){
    return `${environment.webkitURL}${slug}`;
  }

}
